/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleConflictTypes } from './equipment-schedule-conflict-types';


export interface EquipmentScheduleConflictDto { 
    type?: EquipmentScheduleConflictTypes;
    scheduleId?: string;
    scheduleName?: string | null;
    windowStart?: string | null;
    windowEnd?: string | null;
}



